<ng-container *ngTemplateOutlet="navTemplate"></ng-container>

<div class="content">
  <div class="top-gradient-container gradient-{{ gradient }}"></div>
  <div class="absolute-content">
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </div>
</div>
